module.exports = __webpack_public_path__ + "static/img/ylsf1.babc4ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/ylsf1.png
// module id = 3UC9
// module chunks = 64